import beautyIcon from './assets/images/beauty.svg'
import facebookLogo from './assets/images/facebook.svg'
import fashionIcon from './assets/images/fashion.svg'
import homeIcon from './assets/images/home.svg'
import instagramLogo from './assets/images/instagram.svg'
import lifestyleIcon from './assets/images/lifestyle.svg'
import pinterestLogo from './assets/images/pinterest.svg'
import facebookLogoWhite from './assets/images/social/facebook-white.svg'
import instagramLogoWhite from './assets/images/social/instagram-white.svg'
import pinteresLogoWhite from './assets/images/social/pinterest-white.svg'
import tiktokLogoWhite from './assets/images/social/tiktok-white.svg'
import twitterLogoWhite from './assets/images/social/twitter-white.svg'
import youTubeLogoWhite from './assets/images/social/youTube-white.svg'
import tiktokLogo from './assets/images/tiktok.svg'
import twitterLogo from './assets/images/twitter.svg'
import youTubeLogo from './assets/images/youtube.svg'

export const title = 'Chirpyest'

if (!process.env.GATSBY_API_URL) {
  throw new Error('Environment variable GATSBY_API_URL does not exist!')
}

export const IS_DEVELOPMENT = process.env.GATSBY_IS_DEVELOPMENT === 'true'

export const baseURL = process.env.GATSBY_API_URL

export const youtubeVideoURL = 'https://www.youtube.com/embed/5dSMt6ngyH0'

export const printestDefaultImageURL =
  'https://chirpyest.com/src/favicon-512x512.png'

export const HASH_SIGN_IN = '#sign-in'

export const COLORS = {
  lightGrey: '#ABABAB',
  whiteStain: '#FAFBFD',
  dangerRed: '#FF3860',
  ashGrey: '#CDCDCD',
  black: '#000000',
  watermelonPink: '#F27870',
  gainsboro: '#ddd',
  infoBlue: '#0D3C61',
  successGreen: 'green',
  white: '#FFFFFF',
  darkGrey: '#737373',
  darkGrey2: '#000000DE',
  lightBlack: '#232323',
  lightTeal: '#BFD3D0',
  whiteSmoke: '#F6F6F6',
  coolTeal: '#2E7C86',
}

export const TYPOGRAPHY_SIZES = {
  big: 'big',
  small: 'small',
}

export const TYPOGRAPHY_ALIGNMENT = {
  left: 'left',
  right: 'right',
}

export const ENDPOINTS = {
  swapFolderPosition: '/api/v1/shopping-boards/folders/update-position',
  signUp: '/api/v1/auth/signup',
  signIn: '/api/v1/auth/signin',
  sendVerificationOtp: '/api/v1/auth/send-verification-otp',
  verifyEmailOtp: '/api/v1/auth/verify-email-otp',
  verifyCognitoEmail: '/api/v1/auth/verify-cognito-email',
  verifyCaptcha: '/api/v1/auth/verify-recaptcha',
  socialSignUp: '/api/v1/auth/social-signup',
  validateEmailDomain: '/api/v1/auth/validate-email-domain',
  brandsList: '/api/v1/affiliate-networks/brands',
  newBrandsLast30Days: '/api/v1/affiliate-networks/new-brands',
  shortenLink: 'api/v1/brands/shortLinks',
  shareLinkDeclaration: 'api/v1/users/share-link-declaration',
  user: 'api/v1/users/:id/profile',
  userPayments: 'api/v1/users/:id/payments',
  userTransactions: '/api/v1/transactions',
  userTransactionRetailerOptions: '/api/v1/transactions/retailer-options',
  userShareLinks: (userId: string | number) => `/api/v1/users/${userId}/links`,
  userShareLinkRetailerOptions: (userId: string | number) =>
    `/api/v1/users/${userId}/links/retailer-options`,
  overPayments: 'api/v1/users/:id/over-payments',
  extensionEvent: '/api/v1/users/extension-event',
  contactUs: 'api/v1/support',
  newsLetter: 'api/v1/newsletter',
  settings: '/api/v1/settings',
  iosBanners: '/api/v1/settings/prompt-text',
  shoppingBoard: '/api/v1/shopping-boards',
  shoppingBoardNonUser: '/api/v1/shopping-boards/:id',
  updatePositionShoppingBoardItem:
    '/api/v1/shopping-board-items/update-position',
  deleteShoppingBoardItem: '/api/v1/shopping-board-items/:id',
  addItemToShoppingBoard: '/api/v1/shopping-board-items-by-link',
  addItemToShoppingBoardForm: '/api/v1/shopping-board-items-manually',
  blogs: '/api/v1/blogs',
  banner: '/api/v1/banner',
  categories: '/api/v1/categories',
  brandCategories: '/api/v1/brand-categories',
  categoryTopProducts: '/api/v1/top-category-products/:categoryPage',
  featuredBrands: '/api/v1/brands/featured',
  brandById: 'api/v1/brands/brandId',
  brandByInternalId: 'api/v1/brands/internal/:id',
  brandProducts: 'api/v1/brands/brandId/products',
  trending: '/api/v1/trending',
  topProducts: '/api/v1/top-products',
  productById: '/api/v1/products?productId={id}',
  categoryByName: '/api/v1/categories/:categoryName',
  categoryListing: '/api/v1/categories/:categoryName/products',
  allCategory: '/api/v1/products/all',
  getInstagramInfo: '/api/v1/shopping-board-items/instagram',
  getInstagramUserPic: '/api/v1/instagram-profile/username',
  getInstagramImage: '/api/v1/shopping-board-items/base64',
  addInstagramImage: '/api/v1/shopping-board-items/instagram',
  addToShoppingBoard: '/api/v1/shopping-board-items',
  salesChannel: '/api/v1/sales-channel',
  sbFolders: '/api/v1/shopping-boards/:username/folders',
  createSBFolder: '/api/v1/shopping-boards/folders',
  SBFolder: '/api/v1/shopping-boards/folders/:id',
  getSBFolder: '/api/v1/shopping-boards/folder/:id',
  getSBFolderMeta: '/api/v1/shopping-boards/folder/meta/:id',
  addProductsToFolder: '/api/v1/shopping-boards/folder/:id/items',
  SBUpdatePosition: '/api/v1/shopping-board-items/update-position',
  SBFolderUpdatePosition:
    '/api/v1/shopping-boards/folder/:folderId/update-position',
  SBFolderForwardBoard:
    '/api/v1//shopping-boards/folder/:folderId/forward-board',
  deleteItemFromFolder: '/api/v1/shopping-boards/folder/items/:folderItemId',
  getUserRecruits: '/api/v1/dashboard/signed-up-by-you',
  setFolderPrivateToken: '/api/v1/shopping-boards/folder/:id/share',
  getTheChirpyest: '/api/v1/the-chirpyest',
  isRequestingPro: '/api/v1/users/:id/request-pro',
  cms: '/api/v1/cms/:name',
  cmsPro: '/api/v1/cms/pro',
  yourRecruits: '/api/v1/dashboard/your-recruits',
  deleteProduct: '/api/v1/admin/delete-product',
  userCjPids: '/api/v1/affiliate-networks/user-cj-pids',
  cjSurfacePids: '/api/v1/affiliate-networks/cj-surface-pids',
  suspendedBrandIds: '/api/v1/affiliate-networks/suspended-brand-ids',
  editPage: '/api/v1/edit-pages',
  createEditPageFromFolder: '/api/v1/edit-pages/from-folder',
  forwardEditPageToShoppingBoard:
    '/api/v1/edit-pages/:id/forward-to-shopping-board',
  getProductAllimages: '/api/v1/product-all-images',
  getSignedByYourRecruits: '/api/v1/dashboard/signed-up-by-your-recruits',
  parseProduct: '/api/v1/parse-product-link',
  track: 'api/v1/track',
  trackCs: 'api/v1/click-stream-web',
  klaviyoTrigger: '/api/v1/klaviyo/trigger',
  increaseVisitsByOne: '/api/v1/users/:id/update-visit-score',
  joinPages: '/api/v1/join-pages',
}

export const ROUTES = {
  home: '/',
  login: '/login',
  join: '/join',
  joinWithModal: '/join?popup=1',
  brands: '/brands',
  about: '/about',
  help: '/help#tips',
  faq: '/help#faqs',
  cashback: '/user/dashboard#cashback',
  settings: '/user/dashboard#settings',
  paypalSettings: '/user/dashboard#paypalSettings',
  paymentInfo: '/user/dashboard#paymentInfo',
  dashboardChirpyestPro: '/user/dashboard#chirpyest-pro',
  dashboardPerformance: '/user/dashboard#performance',
  signIn: '/#sign-in',
  user: '/user',
  mainDashboard: '/dashboard',
  blog: 'https://chirpyest.com/blog',
  curaeter: '/curaeter',
  contactUs: '/company#contact-us',
  terms: '/company#terms',
  privacy: '/company#privacy',
  member: '/user/member',
  mainMember: '/member',
  featuredBrands: '/featured-brands/',
  mainPersonalInfo: '/personal-info',
  personalInfo: '/user/personal-info',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  mainCreateShareLink: '/share-with-friends',
  createShareLink: '/user/share-with-friends',
  howItWorks: '/how-it-works',
  gate: '/gate',
  category: '/category',
  landing: '/landing',
  chirpyestPro: '/chirpyest-pro',
  theChirpyest: '/chirpyest-community',
  browserExtension: '/best-cash-back-browser-extension-website',
  search: '/search',
  board: '/s',
  mainBoard: '/s/:userName',
  brandPage: '/brands/:brandId',
  fashionCategory: '/category/fashion',
  homeCategory: '/category/home',
  beautyCategory: '/category/beauty',
  lifestyleCategory: '/category/lifestyle',
  yourAccount: '/user/dashboard',
  shop: '/shop',
  joina: '/joina',
  error: '/404',
  myShoppingBoardProxy: '/my-shopping-board',
}

export const FONTS = {
  Schnyder: {
    SchnyderLLight: 'Schnyder L Light',
    SchnyderLBoldItalic: 'Schnyder L Bold Italic',
    SchnyderLBold: 'Schnyder L Bold',
    SchnyderLDemiItalic: 'Schnyder L Demi Italic',
    SchnyderLDemi: 'Schnyder L Demi',
    SchnyderLLightItalic: 'Schnyder L Light Italic',
    SchnyderMBoldItalic: 'Schnyder M Bold Italic',
    SchnyderMBold: 'Schnyder M Bold',
    SchnyderMDemiItalic: 'Schnyder M Demi Italic',
    SchnyderMDemi: 'Schnyder M Demi',
    SchnyderMLightItalic: 'Schnyder M Light Italic',
    SchnyderMLight: 'Schnyder M Light',
    SchnyderSBoldItalic: 'Schnyder S Bold Italic',
    SchnyderSBold: 'Schnyder S Bold',
    SchnyderSDemiItalic: 'Schnyder S Demi Italic',
    SchnyderSLightItalic: 'Schnyder S Light Italic',
    SchnyderSLight: 'Schnyder S Light',
    SchnyderXLBoldItalic: 'Schnyder XL Bold Italic',
    SchnyderXLBold: 'Schnyder XL Bold',
    SchnyderXLDemiItalic: 'Schnyder XL Demi Italic',
    SchnyderXLDemi: 'Schnyder XL Demi',
    SchnyderXLLightItalic: 'Schnyder XL Light Italic',
    SchnyderXLLight: 'Schnyder XL Light',
  },
  Graphik: {
    GraphikBlack: 'Graphik-Black',
    GraphikBlackItalic: 'Graphik-BlackItalic',
    GraphikBold: 'Graphik-Bold',
    GraphikBoldItalic: 'Graphik-BoldItalic',
    GraphikExtralight: 'Graphik-Extralight',
    GraphikExtralightItalic: 'Graphik-ExtralightItalic',
    GraphikLight: 'Graphik Light',
    GraphikLightItalic: 'Graphik-LightItalic',
    GraphikMedium: 'Graphik Medium',
    GraphikMediumItalic: 'Graphik-MediumItalic',
    GraphikRegular: 'Graphik Regular',
    GraphikRegularItalic: 'Graphik-RegularItalic',
    GraphikSemibold: 'Graphik-Semibold',
    GraphikSemiboldItalic: 'Graphik-SemiboldItalic',
    GraphikSuper: 'Graphik-Super',
    GraphikSuperItalic: 'Graphik-SuperItalic',
    GraphikThin: 'Graphik-Thin',
    GraphikThinItalic: 'Graphik-ThinItalic',
  },
}

//TODO: add SM links
export const SOCIAL_MEDIA_LINKS = {
  instargram: 'https://www.instagram.com/chirpyestofficial/',
  tiktok: 'https://www.tiktok.com/@chirpyest',
  pinterest: 'https://www.pinterest.com/chirpyest/',
  facebook: 'https://www.facebook.com/chirpyest/',
  twitter: 'https://twitter.com/chirpyest',
}

export const BREAKPOINTS = {
  xsm: 320,
  sm: 480,
  xmd: 576,
  md: 768,
  mdd: 960,
  lg: 1024,
  xl: 1200,
  xml: 1360,
  xxl: 1400,
  xlg: 1600,
  xxlg: 1840,
}

export const WIDTH_DIMENSIONS = {
  max: 1650,
}

/**
 * Replace the numeric PID in a standard CJ deep link path (`.../links/{pid}/...`).
 */
export const applyCjDedicatedUserPidToTrackingLink = (
  trackingLink: string,
  dedicatedPid: string
): string => {
  if (!trackingLink || !dedicatedPid) return trackingLink
  return trackingLink.replace(/\/links\/\d+\//, `/links/${dedicatedPid}/`)
}

export const regExps = {
  instagramLink: new RegExp('https://www.instagram.com/*'),
}

export const socialMedia = {
  instagram: {
    logo: instagramLogo,
    label: 'https://www.instagram.com/username',
  },
  // facebook: { logo: facebookLogo, label: 'facebook.com/username' },
  // twitter: { logo: twitterLogo, label: 'twitter.com/username' },
  // pinterest: { logo: pinterestLogo, label: 'pinterest.com/username' },
  // youTube: { logo: youTubeLogo, label: 'youtube.com/username' },
}

export const socialMediaArray = [
  { logo: facebookLogo, label: 'facebook.com/username' },
  { logo: twitterLogo, label: 'twitter.com/username' },
  { logo: pinterestLogo, label: 'pinterest.com/username' },
  { logo: youTubeLogo, label: 'youtube.com/username' },
]

export type ProfileSocialPlatformKey =
  | 'instagram'
  | 'facebook'
  | 'twitter'
  | 'pinterest'
  | 'youtube'
  | 'tiktok'
  | 'website'

export interface ProfileSocialLink {
  id: string
  platform: ProfileSocialPlatformKey
  url: string
}

export const PROFILE_SOCIAL_PLATFORMS: {
  key: ProfileSocialPlatformKey
  logo?: string
  profileLogo?: string
  label: string
  placeholder: string
}[] = [
  {
    key: 'instagram',
    logo: instagramLogo,
    profileLogo: instagramLogoWhite,
    label: 'Instagram',
    placeholder: 'Paste your URL',
  },
  {
    key: 'facebook',
    logo: facebookLogo,
    profileLogo: facebookLogoWhite,
    label: 'Facebook',
    placeholder: 'Paste your URL',
  },
  {
    key: 'twitter',
    logo: twitterLogo,
    profileLogo: twitterLogoWhite,
    label: 'Twitter / X',
    placeholder: 'Paste your URL',
  },
  {
    key: 'pinterest',
    logo: pinterestLogo,
    profileLogo: pinteresLogoWhite,
    label: 'Pinterest',
    placeholder: 'Paste your URL',
  },
  {
    key: 'youtube',
    logo: youTubeLogo,
    profileLogo: youTubeLogoWhite,
    label: 'YouTube',
    placeholder: 'Paste your URL',
  },
  {
    key: 'tiktok',
    logo: tiktokLogo,
    profileLogo: tiktokLogoWhite,
    label: 'TikTok',
    placeholder: 'Paste your URL',
  },
  {
    key: 'website',
    label: 'Website',
    placeholder: 'Paste your URL',
  },
]

export const getProfileSocialPlatform = (key: ProfileSocialPlatformKey) =>
  PROFILE_SOCIAL_PLATFORMS.find(p => p.key === key) ||
  PROFILE_SOCIAL_PLATFORMS[0]

/** JSON/JSONB fields from the API may arrive as a string or already-parsed object. */
export const parseJsonField = <T>(value?: string | T | null): T | null => {
  if (value == null) return null
  if (typeof value === 'object') return value as T
  if (typeof value === 'string' && !value.trim()) return null
  try {
    return JSON.parse(value) as T
  } catch {
    return null
  }
}

export const parseProfileLinksFromExternalLinks = (
  externalLinksJson?: string | Record<string, unknown> | null
): ProfileSocialLink[] => {
  const parsed = parseJsonField<{ profileLinks?: ProfileSocialLink[] }>(
    externalLinksJson
  )
  if (!parsed) return []
  const links = parsed.profileLinks
  if (!Array.isArray(links)) return []
  return links.map((link: ProfileSocialLink, index: number) => ({
    id: link.id || `${link.platform}-${index}`,
    platform: link.platform || 'instagram',
    url: link.url || '',
  }))
}

export const formatUrlWithProtocol = (url: string) =>
  url?.match(/^https?:\/\//i) ? url : `https://${url}`

/** Basic URL check; empty strings are treated as valid (optional fields). */
export const isValidProfileUrl = (url: string): boolean => {
  const trimmed = url.trim()
  if (!trimmed) return true

  try {
    const parsed = new URL(formatUrlWithProtocol(trimmed))
    const hostname = parsed.hostname.toLowerCase()
    if (!hostname) return false
    return (
      hostname === 'localhost' ||
      hostname.includes('.') ||
      /^[\d.]+$/.test(hostname)
    )
  } catch {
    return false
  }
}

export const CASHBACK_RANGES = [
  {
    id: 1,
    min: 0,
    max: 2,
    range: 'less than 2%',
  },
  {
    id: 2,
    min: 2,
    max: 5,
    range: '2-5%+',
  },
  {
    id: 3,
    min: 6,
    max: 10,
    range: '6-9%+',
  },
  {
    id: 4,
    min: 10,
    max: Infinity,
    range: '10%+',
  },
]

export const INFO_EMAIL = 'info@chirpyest.com'

const generateAlphabets = () => {
  const alphabets = []
  const start = 'A'.charCodeAt(0)
  const last = 'Z'.charCodeAt(0)
  for (let i = start; i <= last; ++i) {
    alphabets.push(String.fromCharCode(i))
  }
  return alphabets
}

export const ALPHABET_LIST: string[] = generateAlphabets()

// products have network id while brands have network name
export const BRANDS_NETWORK_TYPES: {
  [key: string]:
    | 'commissionJunction'
    | 'rakuten'
    | 'impactRadius'
    | 'partnerize'
    | 'shareASale'
    | 'pepperjam'
    | 'awin'
    | 'ebay'
} = {
  commissionJunction: 'commissionJunction',
  rakuten: 'rakuten',
  impactRadius: 'impactRadius',
  partnerize: 'partnerize',
  shareASale: 'shareASale',
  pepperjam: 'pepperjam',
  awin: 'awin',
  ebay: 'ebay',
  1: 'impactRadius',
  2: 'rakuten',
  3: 'commissionJunction',
  4: 'partnerize',
  5: 'shareASale',
  6: 'pepperjam',
  7: 'awin',
  8: 'ebay',
}

export const WORKER_BASE_URL =
  process.env.GATSBY_PUBLIC_WORKER_BASE_URL ?? 'https://go.chirpyest.com'

export const NETWORK_NID: Record<string, number> = {
  impactRadius: 1,
  rakuten: 2,
  commissionJunction: 3,
  partnerize: 4,
  shareASale: 5,
  pepperjam: 6,
  awin: 7,
  ebay: 8,
}

export const EXTENSION_ID =
  process.env.GATSBY_EXTENSION_ID || 'neepmjdfehbnjjahgjiaadbedkhehgnd'

export const videos = {
  extensionVideo1: {
    mp4:
      'https://chirpyest-public-videos.s3.us-east-2.amazonaws.com/new-videos/1/animation_1_v5.mp4',
    webM:
      'https://chirpyest-public-videos.s3.us-east-2.amazonaws.com/new-videos/1/animation_1_v5.webm',
  },
  extensionVideo2: {
    mp4:
      'https://chirpyest-public-videos.s3.us-east-2.amazonaws.com/new-videos/2/animation_2_v3.mp4',
    webM:
      'https://chirpyest-public-videos.s3.us-east-2.amazonaws.com/new-videos/2/animation_2_v3.webm',
  },
  extensionVideo3: {
    mp4:
      'https://chirpyest-public-videos.s3.us-east-2.amazonaws.com/new-videos/3/Chirpyest_animation_3_v3.mp4',
    webM:
      'https://chirpyest-public-videos.s3.us-east-2.amazonaws.com/new-videos/3/Chirpyest_animation_3_v3.webm',
  },
  extensionVideo4: {
    mp4:
      'https://chirpyest-public-videos.s3.us-east-2.amazonaws.com/new-videos/4/Chirpyest_animation_4_v3.mp4',
    webM:
      'https://chirpyest-public-videos.s3.us-east-2.amazonaws.com/new-videos/4/Chirpyest_animation_4_v3.webm',
  },
  comingSoon: {
    mp4:
      'https://chirpyest-public-videos.s3.us-east-2.amazonaws.com/coming-soon.mp4',
    webM:
      'https://chirpyest-public-videos.s3.us-east-2.amazonaws.com/coming-soon.mp4',
  },
  makeMoney: {
    mp4:
      'https://chirpyest-public-videos.s3.us-east-2.amazonaws.com/new-videos/make-money/make-money-gif.mp4',
    webM:
      'https://chirpyest-public-videos.s3.us-east-2.amazonaws.com/new-videos/make-money/make-money-gif.webm',
  },
}

export const SHOP_MENU_CONFIG = {
  fashion: {
    title: 'fashion',
    link: '#',
    icon: fashionIcon,
  },
  home: {
    title: 'home',
    link: '#',
    icon: homeIcon,
  },
  beauty: {
    title: 'beauty',
    link: '#',
    icon: beautyIcon,
  },
  lifestyle: {
    title: 'lifestyle',
    link: '#',
    icon: lifestyleIcon,
  },
}

export const IOS_APP_LINK =
  'https://apps.apple.com/il/app/chirpyest-cash-back-shopping/id6447595289'

// NOTE: Please update the Documentation if any new events are added
// https://colette-shelton.atlassian.net/wiki/spaces/Chirpyest/pages/12746795/Events
export const CSEvents = {
  // Product
  clickProduct: 'CLICK_PRODUCT',
  viewProduct: 'VIEW_PRODUCT',
  shareProduct: 'SHARE_PRODUCT',

  // Extension events
  openExtension: 'OPEN_EXTENSION',
  closeExtension: 'CLOSE_EXTENSION',
  extensionUninstall: 'EXTENSION_UNINSTALL',

  // Navigation events
  clickHomeNavBtn: 'CLICK_HOME_NAV_BTN',
  clickSearchBrandsNavBtn: 'CLICK_SEARCH_BRANDS_NAV_BTN',
  clickShoppingBoardNavBtn: 'CLICK_SHOPPING_BOARD_NAV_BTN',
  clickAccountNavBtn: 'CLICK_ACCOUNT_NAV_BTN',

  // Brand events
  clickBrand: 'CLICK_BRAND',
  hoverBrand: 'HOVER_BRAND',

  // Shopping board events
  addProductToBoard: 'ADD_PRODUCT_TO_BOARD',
  removeProductFromBoard: 'REMOVE_PRODUCT_FROM_BOARD',
  shareProductFromBoard: 'SHARE_PRODUCT_FROM_BOARD',
  shareBoard: 'SHARE_BOARD',
  viewBoard: 'VIEW_BOARD',
  clickPopupShopBtn: 'CLICK_POPUP_SHOP_BTN',

  // Account events
  clickSignInBtn: 'CLICK_SIGN_IN_BTN',
  clickSignOutBtn: 'CLICK_SIGN_OUT_BTN',
  gotoProfile: 'GOTO_PROFILE',

  // Cashback events
  activateCashback: 'ACTIVATE_CASHBACK',
}

export enum ShoppingBoardView {
  ALL_ITEMS = 'all_items',
  ALL_FOLDERS = 'all_folders',
}

export enum ThirdPartyRefKey {
  Cashbackholic = 'cashbackholic',
  CashbackMonitor = 'cbmonitor-21586',
}

export const thirdPartyRefKeys = [
  ThirdPartyRefKey.Cashbackholic as string,
  ThirdPartyRefKey.CashbackMonitor as string,
]

export interface ThirdPartyRefConfig {
  type:
    | 'referral-bonus' // paid just like user referral ($10)
    | 'normal-attribution' // not paid, just attributed
}

export const thirdPartyRefs: Record<ThirdPartyRefKey, ThirdPartyRefConfig> = {
  [ThirdPartyRefKey.Cashbackholic]: {
    type: 'normal-attribution',
  },
  [ThirdPartyRefKey.CashbackMonitor]: {
    type: 'referral-bonus',
  },
}
